import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export function TwoFactorAuth() {
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code) {
      navigate('/');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-neutral-50" data-id="element-1138">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md" data-id="element-1139">
        <h1 className="text-2xl font-bold mb-6 text-center" data-id="element-1140">
          Two-Factor Authentication
        </h1>
        <form onSubmit={handleSubmit} data-id="element-1141">
          <div className="mb-6" data-id="element-1142">
            <label className="block text-sm font-medium mb-1" htmlFor="code" data-id="element-1143">
              Enter verification code
            </label>
            <input id="code" type="text" className="w-full p-2 border border-neutral-300 rounded" value={code} onChange={e => setCode(e.target.value)} required data-id="element-1144" />
          </div>
          <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700" data-id="element-1145">
            Verify
          </button>
        </form>
      </div>
    </div>;
}